import React from "react";

const TABS = [
  { id: "home",     icon: "🏠", label: "Home" },
  { id: "school",   icon: "🏫", label: "School & Activities" },
  { id: "links",    icon: "🔗", label: "Quick Links" },
  { id: "essential",icon: "🔒", label: "Essential Info" },
];

export default function BottomNav({ active, onTabTap }) {
  return (
    <nav style={{
      position: "fixed", bottom: 0, left: "50%", transform: "translateX(-50%)",
      width: "100%", maxWidth: "var(--app-max-width)", background: "var(--white)",
      borderTop: "1px solid var(--border)", display: "flex",
      padding: "10px 0 20px", zIndex: 100,
    }}>
      {TABS.map((tab) => {
        const isActive = tab.id === active;
        return (
          <div key={tab.id} onClick={() => onTabTap?.(tab.id)} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 3, cursor: "pointer", padding: "4px 0" }}>
            <div style={{ fontSize: 22 }}>{tab.icon}</div>
            <div style={{ fontSize: 10, fontWeight: isActive ? 800 : 700, color: isActive ? "var(--sage)" : "var(--muted)", textAlign: "center", lineHeight: 1.2 }}>{tab.label}</div>
            {isActive && <div style={{ width: 4, height: 4, borderRadius: "50%", background: "var(--sage)", marginTop: 1 }} />}
          </div>
        );
      })}
    </nav>
  );
}
